import React, { useState, useEffect } from 'react';
import '../../styles/Hero.css';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
      badge: '💕 Couple Friendly Hotel',
      title: 'Welcome to',
      titleHighlight: 'AA GRAND HOTEL',
      subtitle: 'Where love meets luxury. Experience world-class hospitality with your special someone. 100% privacy guaranteed.',
      features: ['💕 Couple Friendly', '⏰ Short Stays Available', '🛏️ Luxury Rooms', '📍 Prime Location'],
      ctaText: 'Book Your Stay'
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
      badge: '⏰ Quick Stays • 4 Hours',
      title: 'Short Stays at',
      titleHighlight: 'Best Rates',
      subtitle: 'Need a quick getaway? Enjoy our 4-hour short stay packages starting at just ₹799. Perfect for couples and business travelers.',
      features: ['⏰ 4-Hour Stays', '💕 Couple Friendly', '💰 Best Prices', '🛏️ Premium Comfort'],
      ctaText: 'Book Short Stay'
    },
    {
      id: 3,
      image: 'https://images.unsplash.com/photo-1590490360182-c33d57733427?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
      badge: '💕 Perfect Couple Getaway',
      title: 'Celebrate Love at',
      titleHighlight: 'AA GRAND HOTEL',
      subtitle: 'From romantic stays to quick getaways, we make every moment special. Couple friendly rooms with complete privacy.',
      features: ['💕 Romantic Stay', '🛏️ Luxury Rooms', '🍽️ In-Room Dining', '💫 24/7 Service'],
      ctaText: 'Plan Your Getaway'
    },
    {
      id: 4,
      image: 'https://images.unsplash.com/photo-1571896349842-33c89424ffe2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
      badge: '📍 Heart of Hyderabad',
      title: 'Stay in the Heart of',
      titleHighlight: 'Hyderabad',
      subtitle: 'Perfectly positioned near Ameerpet Metro, Banjara Hills, and all major attractions. Your perfect couple-friendly destination.',
      features: ['📍 Prime Location', '💕 Couple Friendly', '⏰ Short Stays', '🚗 Free Parking'],
      ctaText: 'Find Location'
    },
    {
      id: 5,
      image: 'https://images.unsplash.com/photo-1587474260584-136574528ed5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
      badge: '💕 Privacy Guaranteed',
      title: 'Your Perfect',
      titleHighlight: 'Couple Retreat',
      subtitle: 'Escape the ordinary with our premium couple-friendly rooms. Enjoy quality time together in a comfortable and private setting.',
      features: ['💕 Complete Privacy', '⏰ Flexible Stays', '🛏️ Premium Rooms', '💫 Best Service'],
      ctaText: 'Book Now'
    },
    {
      id: 6,
      image: 'https://images.unsplash.com/photo-1590650516493-21ad3b1cc76b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
      badge: '⭐ Hyderabad\'s Finest',
      title: 'Experience Luxury at',
      titleHighlight: 'AA GRAND HOTEL',
      subtitle: 'The most trusted couple-friendly hotel in Hyderabad. Short stays, luxury rooms, and unforgettable experiences.',
      features: ['💕 Couple Friendly', '⏰ 4-Hour Stays', '🛏️ Luxury Rooms', '📍 Ameerpet'],
      ctaText: 'Explore Now'
    }
  ];

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  // Handle phone call
  const handleCall = () => {
    window.location.href = 'tel:+918019472678';
  };

  return (
    <section className="hero-section">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          <div className="hero-overlay">
            <div className="hero-container">
              <div className="hero-content">
                {/* Badge */}
                <div className="hero-badge">
                  <span className="badge-icon">{slide.badge.split(' ')[0]}</span>
                  {slide.badge.split(' ').slice(1).join(' ')}
                </div>

                {/* Main Heading */}
                <h1 className="hero-title">
                  {slide.title} <span className="highlight">{slide.titleHighlight}</span>
                </h1>
                
                <p className="hero-subtitle">
                  {slide.subtitle}
                </p>

                {/* Features */}
                <div className="hero-features">
                  {slide.features.map((feature, idx) => (
                    <div key={idx} className="feature-item">
                      <span className="feature-icon">{feature.split(' ')[0]}</span>
                      <span>{feature.split(' ').slice(1).join(' ')}</span>
                    </div>
                  ))}
                </div>

                {/* CTA Buttons */}
                <div className="hero-cta">
                  <button onClick={handleCall} className="cta-primary">
                    📞 Call Now
                  </button>
                  <button onClick={handleCall} className="cta-secondary">
                    {slide.ctaText} →
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Slider Controls */}
      <div className="slider-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      <button 
        className="slider-arrow prev" 
        onClick={prevSlide}
        aria-label="Previous slide"
      >
        ‹
      </button>
      <button 
        className="slider-arrow next" 
        onClick={nextSlide}
        aria-label="Next slide"
      >
        ›
      </button>
    </section>
  );
};

export default Hero;